export default __webpack_public_path__ + "static/media/custodyRequestMobile.edcd7fe7.png";